// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"452":"4290d880","650":"eccd8240"}[chunkId] + ".chunk.css";
};